// extracted by mini-css-extract-plugin
export var about = "page-about-module--about--v7pxR";